// const accordions = document.querySelectorAll('.faq__accordion');

// accordions.forEach((element) => {
//   element.addEventListener('click', () => {
//     element.classList.toggle('active');

//     let panel = element.nextElementSibling;

//     panel.style.maxHeight
//       ? panel.style.maxHeight = null
//       : panel.style.maxHeight = panel.scrollHeight + 20 + "px"; // 20px for top and bottom margins
//   });
// });


document.querySelectorAll('.faq__accordions details').forEach(faqAccordion => {
    faqAccordion.querySelector('summary').addEventListener('click', (event) => {
        if (event.target.parentNode.hasAttribute('open')) {
            return ;
        }
        console.log('summary clicked', event.target.parentNode, event.target.parentNode)
        if (window.innerWidth < 768) {
            setTimeout(function() {
                window.scrollTo(0, event.target.getBoundingClientRect().top + window.scrollY - 90)
            }, 50);
        }
        console.log('summary clicked', event.target.parentNode, event.target.parentNode.hasAttribute('open'));
    })
})